export const COMPONENTTYPE = {
    PAGE: 'page',
    ELEMENT: 'element'
};
  